module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/4BFpe2/images/Cover.jpg?1696786074387",
      "alt": "This image is the cover for the book XINO #2, XINO"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("XINO #2, XINO\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Meta-download #002 commence: Eisner-winning master cartoonist David Lapham (Stray Bullets) and co-writer Maria Lapham force our collective psyche into unrecognizable new dimensions in another thrilling installment of the mind-altering, sci-fi-bending anthology XINO! Award-winning and bestselling author Alex Segura (Secret Identity) and Zander Cannon (Kaijumax) embark on an intergalactic journey of revenge; up-and-coming creators Hagai Palevsky and illustrator Carson Thorn invert the work-life balance of corporate America; François Vigneault (Titan) and Artyom Trakhanov (First Knife) deliver bleeding-edge technology to Paleolithic man; and Alissa Sallah (Weeaboo) brings all-too-human nature to the barren landscape of Mars . . . Giddyup!")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Alissa M. Sallah, Zander Cannon, Alex Segura, Francois Vigneault\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Alissa Sallah is a cartoonist (and cosplayer) from small-town Ohio. She edits and contributes to the Bonfire Yearly Anthology (Stratos, Topia, Silk & Metal), has been featured in the Bitch Planet Triple Feature, the Yakuza 6 Song of Life artbook, and was the colorist on the Image comic series Sleepless. Her work can be found at alissasallah.com.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Oni Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 71
// module chunks = 0